export { version as VERSION } from '../../package.json';
export const currentEnv = process.env.REACT_APP_ENV ?? 'local';
export const apiUri = {
  local: {
    getSurvey: `https://bz3odwzek7.execute-api.ap-northeast-2.amazonaws.com/develop/survey`,
    surveyDone: `https://bz3odwzek7.execute-api.ap-northeast-2.amazonaws.com/develop/surveyDone`,
    surveySatisfaction: `https://bz3odwzek7.execute-api.ap-northeast-2.amazonaws.com/develop/surveySatisfaction`,
  },
  develop: {
    getSurvey: `https://bz3odwzek7.execute-api.ap-northeast-2.amazonaws.com/develop/survey`,
    surveyDone: `https://bz3odwzek7.execute-api.ap-northeast-2.amazonaws.com/develop/surveyDone`,
    surveySatisfaction: `https://bz3odwzek7.execute-api.ap-northeast-2.amazonaws.com/develop/surveySatisfaction`,
  },
  staging: {
    getSurvey: `https://shyt7dsg6e.execute-api.ap-northeast-2.amazonaws.com/staging/survey`,
    surveyDone: `https://shyt7dsg6e.execute-api.ap-northeast-2.amazonaws.com/staging/surveyDone`,
    surveySatisfaction: `https://shyt7dsg6e.execute-api.ap-northeast-2.amazonaws.com/staging/surveySatisfaction`,
  },
  prod: {
    getSurvey: `https://4dzt9x9898.execute-api.ap-northeast-2.amazonaws.com/production/survey`,
    surveyDone: `https://4dzt9x9898.execute-api.ap-northeast-2.amazonaws.com/production/surveyDone`,
    surveySatisfaction: `https://4dzt9x9898.execute-api.ap-northeast-2.amazonaws.com/production/surveySatisfaction`,
  },
}[currentEnv];
